import { SEARCH_PARAMS_VALUES } from '../../constants/app.constants';

export enum GraphOption {
  SCANS = 'scans',
  HITS = 'hits',
  SECURED = 'secured',
}

export enum H3MapResolution {
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
}

export enum H3LayerOption {
  HEX = 'Hex',
  POINTS = 'Points',
  NONE = 'None',
}

export enum ScanOption {
  TOTAL_SCANS = 'totalScans',
  TOTAL_UNIQUE_SCANS = 'totalUniqueScans',
}

export const DEFAULT_ZOOM = 8;
export const DEFAULT_CENTER = { lat: 0, lng: 0 };
export const DEFAULT_CENTER_USA_MAP = { lat: 37.0902, lng: -95.7129 };
export const DEFAULT_GOOGLE_ZOOM = 9;
export const MAX_ZOOM = 17;
export const MIN_ZOOM = 4;

export const COLORS_MAP = ['#CDE2FE', '#72ADFF', '#036CFF', '#004FBD', '#052D65'];

export const GRAPH_AXIS_X_FORMATS_MAP: { [key: string]: string } = {
  hour: 'HH',
  day: 'dd',
  month: 'MMM',
  year: 'yyyy',
};

// https://developers.google.com/maps/documentation/javascript/style-reference
export const STYLES_H3_MAP = [
  {
    elementType: 'geometry',
    stylers: [{ color: '#f5f5f5' }],
  },
  {
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [{ color: '#616161' }],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#f5f5f5' }],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#bdbdbd' }],
  },
  {
    featureType: 'poi',
    stylers: [{ visibility: 'on' }],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#757575' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: '#e5e5e5' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#9e9e9e' }],
  },
  {
    featureType: 'poi.attraction',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.business',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.government',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.medical',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.place_of_worship',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.school',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.sports_complex',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ color: '#ffffff' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ color: '#E0E0E0' }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#757575' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#616161' }],
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#9e9e9e' }],
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [{ color: '#e5e5e5' }],
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [{ color: '#eeeeee' }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#D6DBDC' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#9e9e9e' }],
  },
];

export const SECURE_PERCENTAGE_TABS = [
  {
    value: SEARCH_PARAMS_VALUES.hitStatus.all,
    label: 'All',
  },
  { value: SEARCH_PARAMS_VALUES.hitStatus.open, label: 'Opened' },
  { value: SEARCH_PARAMS_VALUES.hitStatus.secured, label: 'Secured' },
  { value: SEARCH_PARAMS_VALUES.hitStatus.closed, label: 'Closed' },
];

export const TOTAL_HITS_TABS = [
  {
    value: SEARCH_PARAMS_VALUES.hitsTypes.all,
    label: 'All',
  },
  { value: SEARCH_PARAMS_VALUES.hitsTypes.lpr, label: 'LPR Hits' },
  { value: SEARCH_PARAMS_VALUES.hitsTypes.direct, label: 'Direct Hits' },
];
